import React from "react";
import { Nft } from "../features";
import { Grid } from "@material-ui/core";

function NftPage() {
  return (
    <>

        <Nft.Container />

    </>
  );
}

export default NftPage;
